/* eslint-disable import/prefer-default-export */
// AUTH TYPES
export const AUTH = {
    namespace: 'auth/',
    REQUEST: 'AUTH_REQUEST',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    LOGOUT: 'LOGOUT',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_REFRESH: 'TOKEN_REFRESH',
    TOKEN_REQUEST_NEW: 'TOKEN_REQUEST_NEW',
    TOKEN_INVALID: 'TOKEN_INVALID',
    CURRENT_USER: 'CURRENT_USER',
    CLEAR: 'CLEAR',
};
// wordings
export const FETCH_WORDING = 'FETCH_WORDING';
// orders
export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_BY_PAGE = 'FETCH_ORDERS_BY_PAGE';
export const EXPORT_ORDERS = 'EXPORT_ORDERS';
export const ORDER_COMMENT_UPDATE = 'ORDER_COMMENT_UPDATE';
export const ORDER_STATUS_UPDATE = 'ORDER_STATUS_UPDATE';
export const DELETE_ORDER = 'DELETE_ORDER';
export const DELETE_ORDER_PANEL = 'DELETE_ORDER_PANEL';
// users
export const FETCH_USERS = 'FETCH_USERS';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
// roles
export const FETCH_ROLES = 'FETCH_ROLES';
// supplier
export const FETCH_SUPPLIERS = 'FETCH_SUPPLIERS';
export const CREATE_SUPPLIER = 'CREATE_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const UPDATE_SUPPLIER_SETTINGS = 'UPDATE_SUPPLIER_SETTINGS';
// building
export const FETCH_BUILDINGS = 'FETCH_BUILDINGS';
export const FETCH_BUILDING = 'FETCH_BUILDING';
export const ADD_BUILDING = 'ADD_BUILDING';
export const UPDATE_BUILDING = 'UPDATE_BUILDING';
export const DELETE_BUILDING = 'DELETE_BUILDING';
// field
export const FETCH_FIELD = 'FETCH FIELD';
export const ADD_FIELD = 'ADD_FIELD';
export const UPDATE_FIELD = 'UPDATE_FIELD';
export const DELETE_FIELD = 'DELETE_FIELD';
// panel
export const ADD_PANEL = 'ADD_PANEL';
export const UPDATE_PANEL = 'UPDATE_PANEL';
export const UPLOAD_PANEL_PRICE = 'UPLOAD_PANEL_PRICE';
export const UPLOAD_PANEL_PRICE_SINGLE = 'UPLOAD_PANEL_PRICE_SINGLE';
export const DELETE_PANEL_PRICE_SINGLE = 'DELETE_PANEL_PRICE_SINGLE';
export const DOWNLOAD_PANEL_PRICES = 'DOWNLOAD_PANEL_PRICES';
export const UPDATE_ALL_PANEL_PRICES = 'UPDATE_ALL_PANEL_PRICES';
export const DELETE_PANEL = 'DELETE_PANEL';
export const FETCH_PANEL_STATUSES = 'FETCH_PANEL_STATUSES';
// other
export const RESET_STATE = 'RESET STATE';




// WEBPACK FOOTER //
// ./src/store/types.js